// import { useEffect, useState } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import TopMenu from "./tabs/TopMenu";
// import General from "./tabs/General";
// import Profile from "./tabs/Profile";
// import SetSalary from "./tabs/SetSalary";
// import Leave from "./tabs/Leave";
// import PaySlip from "./tabs/PaySlip";
// import RemainingLeave from "./tabs/RemainingLeave";
// import GeoLocation from "./tabs/GeoLocation";

// export default function EmployeeDetail() {
//   const { id, tab } = useParams();
//   const navigate = useNavigate();

//   const employee = {
//     firstName: "John",
//     lastName: "Doe",
//     staffId: "43",
//     username: "atss043",
//     email: "john.doe@abc.com",
//     phone: "8792175413",
//     address: "Shanti Nagar Depot - 3",
//     city: "Bangalore",
//     zip: "560027",
//     country: "India",
//     gender: "Male",
//     department: "Maintenance",
//     designation: "Denter",
//     company: "Aarya Trans Solutions Pune",
//     doj: "2024-01-17",
//   };

//   const [activeTab, setActiveTab] = useState(tab || "general");

//   const tabs = [
//   { key: "general", label: "General" },
//   { key: "profile", label: "Profile" },
//   { key: "set-salary", label: "Set Salary" },
//   { key: "leave", label: "Leave" },
//   { key: "pay-slip", label: "Pay Slip" },
//   { key: "remaining-leave", label: "Remaining Leave" },
//   { key: "geo-location", label: "Geo Location" },
//   ];

//   // Default tab redirect
//   useEffect(() => {
//     if (!tab) {
//       navigate(`/employees/${id}/general`, { replace: true });
//     } else {
//       setActiveTab(tab);
//     }
//   }, [tab, id, navigate]);

//   const handleTabClick = (tabName) => {
//     setActiveTab(tabName);
//     navigate(`/employees/${id}/${tabName}`);
//   };

//   return (
//     <div style={{ padding: "16px" }}>
//       <h2>
//         {employee.firstName} {employee.lastName}
//       </h2>

//       {/* Pass tabs array to TopMenu */}
//       <TopMenu activeTab={activeTab} onTabClick={handleTabClick} tabs={tabs} />

//       <div style={{ marginTop: "16px" }}>
//         {activeTab === "general" && <General employee={employee} />}
//         {activeTab === "profile" && <Profile employee={employee} />}
//         {activeTab === "set-salary" && <SetSalary employee={employee} />}
//          {activeTab === "leave" && <Leave employee={employee} />}
//           {activeTab === "pay-slip" && <PaySlip employee={employee} />}
//           {activeTab === "remaining-leave" && <RemainingLeave employee = {employee}/>}
//           {activeTab === "geo-location" && <GeoLocation employee = {employee}/>}
//       </div>
//     </div>
//   );
// }

import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TopMenu from "./tabs/TopMenu";
import General from "./tabs/General";
import Profile from "./tabs/Profile";
import SetSalary from "./tabs/SetSalary";
import Leave from "./tabs/Leave";
import PaySlip from "./tabs/PaySlip";
import RemainingLeave from "./tabs/RemainingLeave";
import GeoLocation from "./tabs/GeoLocation";
import api from "app/services/api";

export default function EmployeeDetail() {
  const { id, tab } = useParams();
  const navigate = useNavigate();

  const [employee, setEmployee] = useState(null);
  const [activeTab, setActiveTab] = useState(tab || "general");

  const tabs = [
    { key: "general", label: "General" },
    { key: "profile", label: "Profile" },
    { key: "set-salary", label: "Set Salary" },
    { key: "leave", label: "Leave" },
    { key: "pay-slip", label: "Pay Slip" },
    { key: "remaining-leave", label: "Remaining Leave" },
    { key: "geo-location", label: "Geo Location" },
  ];

  // ✅ Fetch employee by ID
  useEffect(() => {
    if (!id) return;

    api
      .get(`/api/employees/${id}`)
      .then((res) => {
        setEmployee(res.data.data);
        console.log("Fetched Employee:", res.data.data);
      })
      .catch((err) => {
        console.error("Fetch Error:", err);
      });
  }, [id]);

  // Default tab redirect
  useEffect(() => {
    if (!tab) {
      navigate(`/employees/${id}/general`, { replace: true });
    } else {
      setActiveTab(tab);
    }
  }, [tab, id, navigate]);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    navigate(`/employees/${id}/${tabName}`);
  };

  // ✅ Loading state
  if (!employee) return <div>Loading...</div>;

  return (
    <div style={{ padding: "16px" }}>
      <h2>
        {employee.first_name} {employee.last_name}
      </h2>

      <TopMenu activeTab={activeTab} onTabClick={handleTabClick} tabs={tabs} />

      <div style={{ marginTop: "16px" }}>
        {activeTab === "general" && <General employee={employee} />}
        {activeTab === "profile" && <Profile employee={employee} />}
        {activeTab === "set-salary" && <SetSalary employee={employee} />}
        {activeTab === "leave" && <Leave employee={employee} />}
        {activeTab === "pay-slip" && <PaySlip employee={employee} />}
        {activeTab === "remaining-leave" && (
          <RemainingLeave employee={employee} />
        )}
        {activeTab === "geo-location" && <GeoLocation employee={employee} />}
      </div>
    </div>
  );
}
